
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Toolbar, IconButton, Tooltip, Box, Menu, Badge, Button } from '@mui/material';
import { Menu as MenuIcon, ArrowBackIosNew } from '@mui/icons-material';
import { AppBar, originalTheme } from '../../theme';
import { useDispatch, useSelector } from 'react-redux';
import { startChangeSidebar } from '../../actions';
import { useAuthStore } from '../../stores/usuarios/auth.store';
import { useListCarritoXUser } from '../../hooks/cache';
import { useModalStore } from '../../stores';
import { iconos } from '../../data/iconos-data';




export const NavBarScreen = () => {


    const navigate = useNavigate();
    const { startLogout, usuario } = useAuthStore();
    const { data, isLoading } = useListCarritoXUser(usuario.id);
    const { modalToggleLateral } = useModalStore();
    

    
    const dispatch = useDispatch();    
    const { isSidebarOpen } = useSelector( state => state.iva ); 
    const [anchorElUser, setAnchorElUser] = useState(null);


    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };


    const handleChangeMenu = () => {
        dispatch(startChangeSidebar(!isSidebarOpen))
    }




    return (

        <AppBar sx={{background: originalTheme.palette.primary.main}} position="fixed" open={isSidebarOpen}>
            <Toolbar>
                <IconButton color="inherit" sx={{ mr:2 }} onClick={ handleChangeMenu }>
                    {(isSidebarOpen)
                    ? <ArrowBackIosNew />
                    : <MenuIcon />
                    }
                </IconButton>

                <Box sx={{ flexGrow: 1 }} />

                <Box>
                    <IconButton sx={{ background: 'inherit' }} onClick={() => navigate('/super/buscador/global')}>
                        { iconos['busqueda'] }
                    </IconButton>
                </Box>

                <Box>
                    <IconButton sx={{background:'inherit' }} onClick={() => modalToggleLateral(true)}>
                        <Badge badgeContent={isLoading ? [] : data?.length} color="secondary">
                            { iconos['carrito'] }
                        </Badge>
                    </IconButton>
                </Box>


                <Box sx={{ ml:2 }}>
                    <Tooltip title="Salir de la aplicación">
                        <Button variant='contained' color='secondary' onClick={ startLogout }>Logout</Button>
                    </Tooltip>
                    <Menu
                        sx={{ mt: '47px', width:'300px' }}
                        anchorEl={anchorElUser}
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        open={Boolean(anchorElUser)}
                        onClose={ handleCloseUserMenu }
                    >
                    </Menu>
                </Box>

            </Toolbar>
        </AppBar>

    )
}
